import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Colord } from "colord";
import React from "react";
function lighter(c) {
    // const { colorMode } = useColorMode()
    // const isDark = colorMode === 'dark'
    var newColor = new Colord(c).alpha(0.06);
    return newColor.toRgbString();
}
function getCliPath(param) {
    var distortion = param.distortion;
    var isNegative = distortion < 0;
    distortion = Math.abs(distortion);
    var a = distortion * 100;
    var b = 100 - distortion * 100;
    if (isNegative) {
        return "polygon(0 ".concat(a, "%, 100% 0, 100% ").concat(b, "%, 0 100%)");
    }
    return "polygon(0% 0, 100% ".concat(a, "%, 100% 100%, 0 ").concat(b, "%)");
}
export var GradientRect = function(_param) {
    var _primary = _param.primary, primary = _primary === void 0 ? "#ffa257" : _primary, _secondary = _param.secondary, secondary = _secondary === void 0 ? "#ff71e0" : _secondary, _distortion = _param.distortion, distortion = _distortion === void 0 ? 0.3 : _distortion, rest = _object_without_properties(_param, [
        "primary",
        "secondary",
        "distortion"
    ]);
    primary = lighter(primary);
    secondary = lighter(secondary);
    var clipPath = getCliPath({
        distortion: distortion
    });
    return /*#__PURE__*/ _jsx("div", _object_spread({
        style: {
            clipPath: clipPath,
            width: "80%",
            maxWidth: 800,
            maxHeight: 300,
            height: "70%",
            background: "linear-gradient(45deg, ".concat(primary, " 30%, ").concat(secondary, " 60%)")
        }
    }, rest));
};
